import axios from 'axios';
import { Toast, Dialog } from 'vant';

const service = axios.create({
  timeout: 9000,
});

// 拦截request请求
service.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error),
);

// service.interceptors.response.use(
//   (response) => {
//     if (response.status !== 200) {
//       Toast.fail('接口异常...');
//     }
//     const res = response.data;
//     return res;
//   },
//   (error) => {
//     console.log(error);
//     Dialog.alert({
//       message: error.message,
//     });
//   },
// );
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    // 针对 400 状态码特殊处理
    if (error.response && error.response.status === 400) {
      // 检查是否真的有有效数据
      if (error.response.data) {
        // 如果 400 响应中有有效数据，直接返回数据
        return Promise.resolve(error.response.data);
      }
    }
    
    // 其他错误正常处理
    console.log('请求错误:', error);
    Dialog.alert({
      message: error.message || '请求失败',
    });
    return Promise.reject(error);
  }
);

export default service;
